import { render } from "./UserVoucherListPage.vue?vue&type=template&id=03399d04"
import script from "./UserVoucherListPage.vue?vue&type=script&lang=js"
export * from "./UserVoucherListPage.vue?vue&type=script&lang=js"
script.render = render

export default script